
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Calendar } from "lucide-react";

export const FishingSeasons = () => {
  return (
    <RegulationItem 
      value="seasons" 
      icon={Calendar}
      title="Fishing Seasons"
    >
      <div className="space-y-2">
        <div className="grid grid-cols-2 gap-2">
          <div className="font-medium text-tribal-secondary">Location</div>
          <div className="font-medium text-tribal-secondary">Season</div>
          
          <div className="flex items-center gap-1">
            <span className="h-3 w-3 rounded-full bg-green-500"></span>
            <span>Mountain View Reservoir</span>
          </div>
          <div>Year-Round</div>
          
          <div className="flex items-center gap-1">
            <span className="h-3 w-3 rounded-full bg-green-500"></span>
            <span>Sheep Creek Reservoir</span>
          </div>
          <div>Year-Round</div>
          
          <div className="flex items-center gap-1">
            <span className="h-3 w-3 rounded-full bg-blue-500"></span>
            <span>Lake Billy Shaw</span>
          </div>
          <div>April 1 - Oct 31</div>
          
          <div className="flex items-center gap-1">
            <span className="h-3 w-3 rounded-full bg-blue-500"></span>
            <span>East Fork Owyhee River</span>
          </div>
          <div>April 1 - Oct 31</div>
        </div>
      </div>
    </RegulationItem>
  );
};
